<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="payment_guide">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <div class="meinmenu_title">
              <div>誰でも簡単オーダー収納家具！</div>
              <div>mm/styleご購入ガイド</div>
            </div>
            <p class="guide_title_msg">
              mm/styleではお客様の用途に応じて、1mm単位でサイズ調整できる収納家具を簡単にオーダーいただけます。<br>
              お部屋の雰囲気に合わせてカラーもご選択いただけるので、<span class="pickup">まさに"あなただけのピッタリ収納"のご注文が可能です。</span><br>
              <br>
              ご購入のご案内として、採寸から商品のカスタマイズ、ご注文までの流れをご説明させていただきます。<br>
              多くのお客様にとって、家具のオーダは初めてのご経験かと存じます。本ページの説明をご覧いただき、ぜひ、ご自身の暮らしに最適な収納をご購入ください。<br>
              <br>
              生活に寄り添い住空間にフィットする家具のご提供により、お客様の暮らしづくりのお手伝いができれば、大変嬉しく思います。
            </p>
            <img :src="getImage('top/payment_guide/00_flow.webp')">
            <!-- <div id="guide_flow">
              <div>設置場所の<br>サイズを測る</div>
              <div>商品を<br>カスタマイズする</div>
              <div>金額をご確認し<br>ご注文</div>
            </div> -->
          </section>
          <!-- 1.設置場所のサイズを測る -->
          <section>
            <h2>1.設置場所のサイズを測る</h2>
            <p>
              オーダー家具のカスタマイズを行う際、最も心配なのはサイズの指定ではないでしょうか。<br>
              オーダー家具はお客様ひとりひとりのために製造されますので、サイズを間違えて注文された場合の返品や交換はお受けできません。<br>
              そのようなことがないように、下記をご参考いただき、設置場所の採寸をお願いいたします。
            </p>
            <section class="procedure">
              <h3>①必要な道具を用意する</h3>
              <div>
                <img :src="getImage('top/payment_guide/01-01_size.webp')">
                <div>
                  <p>
                    採寸には、メジャーが必須アイテムです。<br>
                    オススメはステンレス製で幅が太く、ストッパーのついているメジャーです。100円ショップなどでも購入いただけます。<br>
                    メジャーをたわませず、斜めにならないように測ってください。
                  </p>
                </div>
              </div>
            </section>
            <section class="procedure">
              <h3>②設置場所の空間サイズを測る</h3>
              <div class="">
                <img :src="getImage('top/payment_guide/01-02_size.webp')">
                <div>
                  <p>
                    壁から壁まで、または天井から床まで、ピッタリと収まるサイズでオーダーしたい場合は、設置場所の幅・高さを6箇所ずつ測ってください。<br>
                    家の壁はまっすぐに見えて、少し歪んでることがほとんどです。傾きを考慮してサイズを決めるため、必ず画像で示している箇所の採寸をお願いします。<br>
                    なお、床に巾木があったり、壁にコンセントがあったり、天井に廻り縁や火災報知器などの障害物がある場合がございます。
                  </p>
                  <!-- <div class="detail_btn3 btn_pos_left">採寸の注意事項はこちら</div> -->
                </div>
              </div>
            </section>
            <section class="procedure">
              <h3>③商品サイズを決める</h3>
              <div>
                <img :src="getImage('top/payment_guide/01-03_size.webp')">
                <div>
                  <p>
                    計測した実測値の一番小さい値が空間のサイズとなります。<br>
                    オーダーしたい家具のサイズは、実際に設置したい空間サイズより左右や上下、奥行き方向に10mm程度ずつ隙間ができるようにしてください。<br>
                    計10mmの隙間であれば、ぴったりと納まっているように見えます（巾木や廻り縁がある場合は、その内側からの寸法となります）。<br>
                    扉などがある商品の場合、開けたときに他の家具や照明、火災報知器などに当たらないようにサイズを調整してください。
                  </p>
                  <!-- <div class="detail_btn3 btn_pos_left">サイズ決定の注意事項はこちら</div> -->
                </div>
              </div>
            </section>
            <section class="caution_procedure">
              <div>
                <h3>家具を壁に固定する場合</h3>
                <div class="caution_message">
                  <img :src="getImage('top/payment_guide/01-04_pillar.webp')">
                  <div>
                    <p>
                      吊戸棚（フロート収納）や食器棚（カップボード）等、壁に取り付ける商品の場合、壁面に下地（柱）があるか確認する必要があります。<br>
                      壁への固定が必要な商品かどうかは、商品詳細ページをご覧ください。<br>
                      下地材さえうまく見つけることが出来れば、家具の壁止めはどなたでも可能です。<br>
                      壁をノックして音で確認する方法もありますが、市販の下地探しや下地センサーを活用いただくことで、 より確実に確認することができます。<!-- 詳細は以下をご覧ください。 -->
                    </p>
                    <!-- <div class="detail_btn3 btn_pos_left">下地の探し方はこちら</div> -->
                  </div>
                </div>
              </div>
              <div class="detail_btn5 btn_pos_center" @click="route('SupportInput')">お問い合わせはこちら 〉〉</div>
            </section>
          </section>
          <!-- 2.商品をカスタマイズする -->
          <section>
            <h2>2.商品をカスタマイズする</h2>
            <p>
              採寸して決定した商品サイズを元に、商品のカスタマイズをします。<br>
              扉やカウンターもそれぞれカラーを選べるので、お部屋の雰囲気に合わせてお好きな組み合わせをお選びください。<br>
              お客様だけのオーダー家具をプランニングしてください。
            </p>
            <div class="procedure">
              <h3>①お好きな商品を選ぶ</h3>
              <div>
                <img :src="getImage('top/payment_guide/02-01_customize.webp')">
                <div>
                  <p>
                    用途に応じて、商品カテゴリの中から商品を選択します。<br>
                    あらかじめ決められたデザインから、設置する場所や収納するものの大きさ、見た目等でお好きな商品をお選びください。<br>
                    商品はそれぞれ、デザイン、扉の有無、選択できるカラー、材料などが異なります。ご自身のイメージにあったものをお選びください。
                  </p>
                  <div class="detail_btn7 btn_pos_left" @click="routeCategory()">商品を選ぶ</div>
                </div>
              </div>
            </div>
            <div class="procedure">
              <h3>②商品サイズ、カラーを選択する</h3>
              <div>
                <img :src="getImage('top/payment_guide/02-02_customize.webp')">
                <div>
                  <p>
                    商品のカスタマイズ画面にて、ご希望の商品サイズ・カラーを選択しましょう。<br>
                    商品毎に選択可能な幅・高さ・奥行きサイズが異なりますので、 入力可能な範囲内でのご指定をお願いします。<br>
                    サイズは1mm単位でご指定いただけます。<br>
                    配送料金を計算するために、お届け先の郵便番号もご入力ください。
                  </p>
                </div>
              </div>
            </div>
            <div class="procedure">
              <h3>③組立設置サービスのご選択</h3>
              <div>
                <img :src="getImage('top/payment_guide/02-03_customize.webp')">
                <div>
                  <p>
                    組立設置に不安があるお客様は、プロの業者に依頼することもできます。<br>
                    ご依頼される場合はカスタマイズ画面の「組立設置サービスの選択」にて「あり」をクリックしてください。
                  </p>
                  <!-- <div class="detail_btn3 btn_pos_left">組立設置サービス詳細はこちら</div> -->
                </div>
              </div>
            </div>
            <div class="detail_btn5 btn_pos_center" @click="route('SupportInput')">お問い合わせはこちら 〉〉</div>
          </section>
          <!-- 3.金額を確認しご注文 -->
          <section>
            <h2>3.価格を確認しご注文</h2>
            <p>
              ご選択いただいたサイズ・カラー・配送先情報により、お見積り金額をリアルタイムに計算いたします。<br>
              金額や商品仕様、搬入経路に問題がなければいよいよご購入です。<br>
              ご注文に際して、不安やことや気になることがあれば、ページ下部でご紹介しているサポート窓口までお気軽にご連絡ください。
            </p>
            <div class="procedure">
              <h3>①見積り価格、図面、カラーを確認</h3>
              <div>
                <img :src="getImage('top/payment_guide/03-01_order.webp')">
                <div>
                  <p>
                    カスタマイズが終了したら、ページ最下部の「図面/見積り」ボタンをクリックしてください。<br>
                    カスタマイズされた商品の価格・図面が表示されます。<br>
                    ご確認いただき問題がなければ、「カートに追加」をクリックしてください。商品がカートに追加されます。
                  </p>
                </div>
              </div>
            </div>
            <div class="procedure">
              <h3>②搬入経路の寸法を確認する</h3>
              <div>
                <img :src="getImage('top/payment_guide/03-02_order.webp')">
                <div>
                  <p>
                    お届けの際、玄関・室内ドアや階段の幅、マンションのエレベーターの大きさなどが理由で、家具を運べないことがあります。<br>
                    見積り金額の確認画面に梱包サイズ（お届け時の段ボールサイズ）を表示しておりますので、不安な場所は必ず計測ください。 必要に応じて、商品サイズを小さくするなどの工夫が必要です。
                  </p>
                  <!-- <div class="detail_btn3 btn_pos_left">搬入経路の注意事項はこちら</div> -->
                </div>
              </div>
            </div>
            <div class="procedure">
              <h3>③ご発注</h3>
              <div>
                <img :src="getImage('top/payment_guide/03-03_order.webp')">
                <div>
                  <p>
                    搬入経路の問題がないことを確認されたら、カート画面の「注文へ進む」ボタンをクリックしてください。<br>
                    お届け先のご入力や、決済方法のご選択をしてください。<br>
                    なお、mm/styleの商品は、お客様のオーダーに合わせてひとつひとつ製造する商品なので、キャンセルやご注文後の変更はお受けできません。よくご確認のうえで、ご注文ください。
                  </p>
                </div>
              </div>
            </div>
            <div class="detail_btn5 btn_pos_center" @click="route('Faq')">よくある質問はこちら 〉〉</div>
          </section>
          <!-- 4.お支払い方法について -->
          <section>
            <h2>4.お支払い方法について</h2>
            <p>
              お支払い方法は複数あります。<br>
              ご注文が完了したあとはお支払い方法の変更はできません。<br>
              <br>
              ※ 個人のお客様がご利用いただける支払い方法は「クレジットカード」、「銀行振込」となります。<br>
              <span v-if="isCorpLogin">※ 法人のお客様は、「<span class="link" @click="deferPayment">後払いサービス</span>」をご利用いただけます。 ＊申込みと審査が必要となります。</span>
            </p>
          </section>
          <div v-if="!isHaseko">
            <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_PRPIC_ON, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcPaymentGuide',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'paymentGuide', key: 'dcPaymentGuide', title: 'ご購入ガイド', route: 'DcPaymentGuide'}
      ],
      user: {}
    }
  },
  computed: {
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    },
    isCorpLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 2) return true
      if (this.user.userLevel === 1) return true
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (params) {
      if (DC_PRPIC_ON === 1) {
        this.$router.push({
          name: 'DcPrpic',
          query: params
        })
      } else {
        this.$router.push({
          name: 'DcCategory',
          query: params
        })
      }
    },
    deferPayment: function () {
      this.$router.push({
        name: 'DcPaymentService'
      })
    }
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcPaymentGuide.vue